import { registerQuery } from 'data-fetching-client';
const MockVariantDefinition = {
  name: 'sectionStyles',
  preview: '',
  fields: [{
    type: 'color',
    name: 'bgColor',
    label: 'BG color',
    css_variable: 'bg-color',
    default: {
      color: '#000000'
    }
  }, {
    type: 'color',
    name: 'textColor',
    label: 'Text color',
    css_variable: 'text-color',
    default: {
      color: '#FFFFFF'
    }
  }],
  defaultVariantsConfig: {
    sectionVariant1: {
      label: 'Section variant 1',
      values: {
        bgColor: {
          color: '#1233a2'
        },
        textColor: {
          color: '#aaabbb'
        }
      }
    },
    sectionVariant2: {
      label: 'Section variant 2',
      values: {
        bgColor: {
          color: '#26b485'
        }
      }
    },
    sectionVariant3: {
      label: 'Section variant 3',
      values: {
        bgColor: {
          color: '#ad1339'
        }
      }
    }
  }
};
const MockOverrides = {
  sectionVariant1: {
    bgColor: {
      color: '#ecc70e'
    }
  }
};
export const GET_BULK_VARIANTS = registerQuery({
  fieldName: 'bulkVariants',
  fetcher() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve({
          sectionStyles: {
            variantDefinition: MockVariantDefinition,
            overrides: MockOverrides
          }
        });
      }, 300);
    });
  }
});
export const GET_VARIANT_DEFINITION = registerQuery({
  fieldName: 'variantDefinition',
  fetcher({
    variantDefinitionName
  }) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(variantDefinitionName === 'sectionStyles' ? MockVariantDefinition : null);
      }, 300);
    });
  }
});
export const GET_VARIANT_OVERRIDES = registerQuery({
  fieldName: 'variantOverrides',
  fetcher({
    variantDefinitionName
  }) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(variantDefinitionName === 'sectionStyles' ? MockOverrides : null);
      }, 300);
    });
  }
});